const clientId = 'a199bc0a86bb4c6db1efa3f061bd8efc';
module.exports = clientId;
